<template>
	<div class="inline-flex w-fit items-center text-gray-800">
		<label v-if="label" class="mr-4">{{ label }}</label>
		<HeadlessUiSwitch
			:model-value="modelValue"
			:class="[
				'inline-flex items-center rounded-full p-1',
				'cursor-pointer transition-colors duration-200 ease-in-out',
				'focus:ring-blue-deep focus:outline-none',
				sizes[size].outerSize,
				backgroundColor,
			]"
			@update:model-value="$emit('update:modelValue', $event)"
		>
			<span class="sr-only">{{ label }}</span>
			<span
				aria-hidden="true"
				:class="[
					'pointer-events-none',
					'rounded-full shadow-md',
					'my-2 transition duration-300 ease-in-out',
					modelValue ? sizes[size].translateX : 'translate-x-0',
					sizes[size].innerSize,
					buttonColor,
				]"
			/>
		</HeadlessUiSwitch>
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import type { PropType } from 'vue';
import { Switch as HeadlessUiSwitch } from '@headlessui/vue';

type ElementType = 'outerSize' | 'innerSize' | 'translateX';
type Size = 'small' | 'large';

const sizes: Record<Size, Record<ElementType, string>> = {
	small: {
		outerSize: 'w-[36px] h-[19px] ',
		innerSize: 'h-[14.62px] w-[14.69px] ',
		translateX: 'translate-x-[0.90rem]',
	},
	large: {
		outerSize: 'w-[49px] h-[26px]',
		innerSize: 'h-[20px] w-[20px]',
		translateX: 'translate-x-[1.30rem]',
	},
};

export default defineComponent({
	components: { HeadlessUiSwitch },
	props: {
		label: {
			type: String as PropType<string | undefined>,
			default: undefined,
		},
		modelValue: {
			type: Boolean as PropType<boolean>,
			default: false,
		},
		buttonColor: {
			type: String as PropType<string>,
			default: 'bg-w-blue-deep',
		},
		backgroundColor: {
			type: String as PropType<string>,
			default: 'bg-white',
		},
		size: {
			type: String as PropType<Size>,
			default: 'small',
		},
	},
	emits: ['update:modelValue'],
	setup: () => ({ sizes }),
});
</script>
